import {
  ApacCandidateFooter,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';

import { useHeaderFooterLinkProvider } from 'src/components/HeaderFooterLinks/HeaderFooterLinks';
import { useHeaderFooter } from 'src/hooks/useHeaderFooter';
import type { FooterProps } from 'src/types';

const Footer = ({ width, loading, error }: FooterProps) => {
  const { authenticationStatus } = useHeaderFooter({
    loading,
    error,
  });
  const footerLink = useHeaderFooterLinkProvider();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={footerLink}>
      <ApacCandidateFooter
        authenticationStatus={authenticationStatus}
        isExpandedVersion={true}
        widthMode={width}
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Footer;
